<template>
  <b-overlay
    :show="drProcess || drProcessTmp"
    opacity="0.5"
    spinner-variant="primary"
    rounded="md"
    class="div-container text-cente"
  >

    <template
      v-slot:overlay
    >
    
  
      <div style="display:flex; align-items: center; flex-direction: column;">
        <img src="@/assets/images/loaders/pre_dr.gif"><br>
        <strong>GENERATING DIGITAL RECONSTRUCTION DATA</strong>
        <div
          v-if="drTask !== null"
        >
          <svg
            height="20"
            width="95"
            style="margin: 10px"
          >
            <circle
              cx="10"
              cy="10"
              r="10"
              :fill="(drTask >= '11.1') ? (drTask === '11.1') ? '#83C2C1' : '#068380' : '#cacacc'"
            />
            <circle
              cx="35"
              cy="10"
              r="10"
              :fill="(drTask >= '11.2') ? (drTask === '11.2') ? '#83C2C1' : '#068380' : '#cacacc'"
            />
            <circle
              cx="60"
              cy="10"
              r="10"
              :fill="(drTask >= '11.3') ? (drTask === '11.3') ? '#83C2C1' : '#068380' : '#cacacc'"
            />
            <circle
              cx="85"
              cy="10"
              r="10"
              :fill="(drTask >= '11.4') ? (drTask === '11.4') ? '#83C2C1' : '#068380' : '#cacacc'"
            />
          </svg>
        </div>
        <small v-if="tasktype_status[0] !== undefined && tasktype_status[0].progress.timestamp !== ''">Last Update: {{ tasktype_status[0].progress.timestamp }}</small>
        <b-button
          v-if="drTask !== null"
          :disabled="stopping"
          class="mt-1"
          size="sm"
          variant="danger"
          @click="stop_tasklist()"
        >
          <span v-if="!stopping">STOP</span>
          <span v-if="stopping">Stopping...</span>
        </b-button>
      </div>
    </template>
    <b-overlay
      v-if="!drProcess && !drProcessTmp"
      :show="showComputing"
      opacity="0"
      spinner-variant="primary"
      spinner-small
      rounded="md"
    >
  
      <template
        v-slot:overlay
      >
        <div
          style="display:flex; align-items: center; flex-direction: column;"
        >
          <b-spinner
            style="width: 4rem; height: 4rem;"
          />
          <div class="mt-1">
           
            <span v-if="!updating && hasImages ">Loading...<br></span>
            <span v-if="updating">Updating figures...<br></span>
            <small v-if="status.progress.timestamp !== ''">Last Update: {{ status.progress.timestamp }}</small>
          </div>
        </div>
      </template>
      <div
        class="div-container text-center"
      >
     
    
        <CoolLightBox
          :items="lightbox"
          :index="lbIndex"
          :use-zoom-bar="true"
          @close="lbIndex = null"
          style="position: absolute; z-index: 1000;"
        />
        <b-container
          v-if="!showComputing && hasImages"
          fluid
          class="px-4"
        >
          <b-button-toolbar
            justify
          >
            <b-button-group
              class="my-1"
            >
         
              <b-button
                :variant="(technique === 'PCA') ? 'primary' : 'outline-primary'"
                @click="technique ='PCA'"
              >
             
                PCA 
              </b-button>
              <b-button
                :variant="(technique === 'tsne') ? 'primary' : 'outline-primary'"
                @click="technique ='tsne'"
              >
                tSNE
              </b-button>
              <b-button
                :variant="(technique === 'uMap') ? 'primary' : 'outline-primary'"
                @click="technique ='uMap'"
              >
                uMap
              </b-button>
            </b-button-group>
            <b-button-group
              class="m-1"
            >
              <b-button
                :variant="(type === 'phenograph') ? 'primary' : 'outline-primary'"
                @click="type ='phenograph'"
              >
                Phenograph
              </b-button>
              <b-button
                :variant="(type === 'flowsom') ? 'primary' : 'outline-primary'"
                @click="type ='flowsom'"
              >
                flowsom
              </b-button>
              <b-button
                :variant="(type === 'kmeans') ? 'primary' : 'outline-primary'"
                @click="type ='kmeans'"
              >
                kMeans
              </b-button>
            </b-button-group>
            <b-button-group
              class="my-1"
              style="float:right"
            >
              <b-button
                variant="outline-primary"
                @click="updateFigures"
                v-if="version.time_update == null || version.time_update == undefined"
              >
                UPDATE FIGURES
              </b-button>
            </b-button-group>
          </b-button-toolbar>
          <b-row>
            <b-col class="clusters">
              <b-img
                fluid-grow
                :src="'data:image/jpeg;base64, ' + charts['dr_clusters_'+ technique +'_' + type + '.png']"
                @click="lbIndex = 0"
              />
            </b-col>
            <b-col class="clustering">
              <b-img
                fluid-grow
                :src="'data:image/jpeg;base64, ' + charts['clustering_'+ technique +'_markers.png']"
                @click="lbIndex = 1"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col class="heatmap">
              <b-img
                fluid-grow
                :src="'data:image/jpeg;base64, ' + charts[type + '_heatmap.png']"
                @click="lbIndex = 2"
              />
            </b-col>
            <b-col
              class="legend"
              style="display: flex; align-items: stretch;"
            >
              <b-container class="bg-light mt-4 p-1">
                <b-form-group
                  class="mt-1"
                >
               

              
                  <h2 class="mb-2">
                    Annotation
                  </h2>
                  <div
                  
                    v-for="(annotationItem, index) in annotations[type]"
                    :key="index"
                    style="text-align:left"
                  >
                    <strong>{{ annotations[type][index].cluster.name }}</strong>➟ {{ annotations[type][index].name }}<br>
                  </div>
                </b-form-group>
                <b-button
                  v-if="version.time_update == null || version.time_update == undefined"
                  variant="outline-primary"
                  @click="openForm()"
                >
                  ADD ANNOTATION
                </b-button>
              
              
              </b-container>
            </b-col>
          </b-row>
          <div>
            <b-button
              class="mb-2 mt-5"
              variant="primary"
              @click="prepare_dr()"
              v-if="version.time_update == null || version.time_update == undefined"
            >
              PROJECT ANNOTATIONS TO ENTIRE DATASET
            </b-button>
            <b-button
              class="mb-2 mt-5"
              variant="primary"
              :disabled="false"
              @click="prepare_dr()"
              v-else
            >
              GENERATING DIGITAL RECONSTRUCTION DATA ...
            </b-button>
          </div>
        </b-container>
      </div>
    </b-overlay>
    <div v-if="show_ann" class="add-annot" id="add-annot">
      <b-form-group
      class="mt-1"
      style="text-align:left"

    >
    <h2> Add annotation</h2>
    
      <v-select
  v-model="new_annot_cluster"
  placeholder="Select a cluster"
  tag-placeholder=" "
  label="name" 
  track-by="cluster"
  :options="new_annot.annotationOptions"
  :multiple="true"
  :taggable="false"
  class="mr-1 mb-2"
></v-select>
   <!----
      <vue-multi-select
      ref="multiSelect"
      style="margin-bottom: 10px;"
      v-model="new_annot_cluster"
      placeholder="Select a name"
      :btnLabel="btnLabel"
      label="name"
      search
      historyButton
      placeHoldr
      :options="options"
      :selectOptions="new_annot.annotationOptions">
      <template v-slot:option="{option}">
        <input type="checkbox"/>
        <span>{{option.name}}</span>
        </template>
    
    </vue-multi-select>
    OTRO--
        <v-select
       v-model="new_annot_cluster"
        placeholder="Select a cluster"
        tag-placeholder=" "
        label="name"
        track-by="cluster"
        :options="new_annot.annotationOptions"
        :multiple="true"
        :taggable="false"
        class="mr-1 mb-2"
  ></v-select>-->

    <!----

      <v-select
        v-model="new_annot_cluster"
        placeholder="Select a cluster"
        tag-placeholder=" "
        label="name"
        track-by="cluster"
        :options="new_annot.annotationOptions"
        :multiple="false"
        :taggable="false"
        class="mr-1 mb-2"
      />
      <h6>
      
      </h6>-->

      <v-select
        v-model="new_annot_name"
        placeholder="Search or add a name"
        tag-placeholder=" "
        label="name"
        :options="new_annot.cellNames"
        :multiple="false"
        :taggable="true"
        class="mr-1"
        @tag="addName"
      
      />

      <b-button
        variant="outline-primary"
        class="mt-2"
        @click="addAnnotations"
      >
        ADD ANNOTATION
      </b-button>
      <b-button
        variant=""
        class="mt-2"
        style="margin-left:10px;"
        @click="cancelAnnotations"
      >
      CANCEL     
     </b-button>
    </b-form-group>

    </div>
  </b-overlay>
 
</template>
<script>
import Vue from 'vue'
import Swal from 'sweetalert2'
import markerlist from '../../../markerList.vue'
import vSelect from 'vue-select'
import {
  BSpinner, BButtonToolbar, BButtonGroup, BButton, BImg, BRow, BCol, BContainer, BFormGroup, BOverlay,
} from 'bootstrap-vue'
import store from '@/store/index'
import axios from 'axios'
import 'vue-select/dist/vue-select.css'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import vueMultiSelect from 'vue-multi-select';


const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BSpinner,
    vSelect,
    Swal,
    BButtonToolbar,
    vueMultiSelect,
    BButtonGroup,
    BButton,
    BImg,
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    CoolLightBox,
    markerlist,
    BOverlay,
  },
  props: {
    
    version: {
      required: false,
      type: [String, Object],
      default: null,
    },
    taskStatus: {
      required: false,
      type: [String, Object, Array],
      default: []
    },
    node_id:{
      required: false,
      type: Number,
      default: 0
    },
    project_id:{
      required: false,
      type: Number,
      default: 0

    }
  },
  data() {
    return {
      drProcess: false,
      drProcessTmp: false,
      new_annot: [],
      drTask: null,
      sth_new:false,
      new_annot_name:'',
      new_annot_cluster:[],
      values: [],
      btnLabel: new_annot_cluster => `Select a name  `,
      
      images: [
        { image: 'clustering_PCA_markers.png', data: '' },
        { image: 'clustering_tsne_markers.png', data: '' },
        { image: 'clustering_uMap_markers.png', data: '' },
        { image: 'dr_clusters_PCA_flowsom.png', data: '' },
        { image: 'dr_clusters_PCA_kmeans.png', data: '' },
        { image: 'dr_clusters_PCA_phenograph.png', data: '' },
        { image: 'dr_clusters_tsne_flowsom.png', data: '' },
        { image: 'dr_clusters_tsne_kmeans.png', data: '' },
        { image: 'dr_clusters_tsne_phenograph.png', data: '' },
        { image: 'dr_clusters_uMap_flowsom.png', data: '' },
        { image: 'dr_clusters_uMap_kmeans.png', data: '' },
        { image: 'dr_clusters_uMap_phenograph.png', data: '' },
        { image: 'flowsom_heatmap.png', data: '' },
        { image: 'kmeans_heatmap.png', data: '' },
        { image: 'phenograph_heatmap.png', data: '' },
      ],
      technique: 'PCA',
      show_ann: false,
      type: 'phenograph',
      updating: false,
      lbIndex: null,
      timer: null,
      annotation: [],
      versionAnnotation: [],
      annotations: {
        phenograph: [],
        kmeans: [],
        flowsom: [],
      },
      annotationsB: [],
      celltypes: [],
      test: null,
      status: { annotation: null, markers: [], progress: { timestamp: '' } },
      showComputing: false,
      annotationStatus: false,
      imageStatus: false,
      hasImages: false,
      tasktype_status: [],
      stopping: false,
      options: {
        multi: true,
        groups: false,
        labelName: 'name',
        cssSelected: option => (option.selected ? { 'color': '#008380' } : ''),
      },
    }
  },
  computed: {
    marker_list() {
      const markers = []
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.version.markers.length; index++) {
        const element = this.version[index]
        markers.push(element.marker_id)
      }
      return markers
    },
    charts() {
      const chart = {}
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.images.length; index++) {
        const element = this.images[index]
        chart[element.image] = element.data
      }
      console.log(chart)
      return chart
    },
    lightbox() {
      const lightbox = [
        `data:image/jpeg;base64, ${this.charts[`dr_clusters_${this.technique}_${this.type}.png`]}`,
        `data:image/jpeg;base64, ${this.charts[`clustering_${this.technique}_markers.png`]}`,
        `data:image/jpeg;base64, ${this.charts[`${this.type}_heatmap.png`]}`,
      ]
      return lightbox
    },
    annotationOptions() {
      const options = []
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.annotation.length; index++) {
        const element = this.annotation[index]
        if (this.type === element.cl_method) {
          const name =  (element.cluster === element.annotation) ? element.cluster : `${element.annotation}(${element.cluster})` 
          const { cluster } = element
          options.push({ name, cluster })
        }
      }
      return options
    },
    ready() {
      let ready = true
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.images.length; index++) {
        const element = this.images[index]
        if (element.status === 0 || element.data === '') {
          ready = false
        }
      }
      return ready
    },
  },
  watch: {
    version() {
      this.resetData()
    },
    hasImages() {
      if (this.hasImages === true && this.annotationStatus === true) {
        this.getData()
        this.$emit('hasImages', true)
      } else {
        this.$emit('hasImages', false)
      }
    },
    images() {
      const images = this.images.filter(el => el.data !== '')
      this.showComputing = (images.length === 0)
      console.log('showComputing', images.length)
    },
    taskStatus() {
      if (this.taskStatus.tasktype_status.length > 0) {
        this.tasktype_status = this.taskStatus.tasktype_status
      } else if (this.tasktype_status.length > 0) {
        this.tasktype_status = []
      }
    },
    tasktype_status() {
      if (this.tasktype_status.length === 0) {
        this.drProcess = false
      } else {
        this.checkInTask()
      }
    },
  },
  mounted() {
    this.resetData()
    this.taskProgress()
  
  
  },
  beforeDestroy() {
    clearInterval(this.timer)

  },
  methods: {
     
    handleClose() {
      return this.sth_new;
    },
    handleEscapeKey() {
      this.$emit('escape_pressed');
    },
    returnIndex() {
      // Lógica que deseas ejecutar al presionar la tecla "Escape"
      // Por ejemplo, establecer una variable en null
     return this.lbIndex 
    },
    escape_pressed() {
      // Lógica que deseas ejecutar al presionar la tecla "Escape"
      // Por ejemplo, establecer una variable en null
      this.lbIndex = null;
    },
   
    cancelAnnotations(){
      this.new_annot_name = ''
      this.new_annot_cluster = []
      this.show_ann = false;
    },
    checkInTask() {
      const tasks = ['11.1', '11.2', '11.3', '11.4']
      console.log('check', this.tasktype_status)
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.tasktype_status.length; index++) {
        const element = this.tasktype_status[index]
        if (tasks.includes(element.json.task_type)) {
          this.drProcess = true
          this.drTask = element.json.task_type
          this.drProcessTmp = false
        }
      }
    },
    stop_tasklist() {
      this.$swal({
        title: 'Are you sure?',
        text: "All tasks will be stopped.You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, STOP all tasks!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const id = this.project_id;
          //const { id } = this.$route.params
         // axios.post(`${url}:${port}/taskqueue-stop/${id}`, { tasks: ['11.1', '11.2', '11.3', '11.4'] }, { headers })
          this.stopping = true
        }
      })
    },
    setTimer(id) {
      this.timer = setInterval(() => {
       // this.getStatus()
       this.getPendingTask(id)
      }, 2000)
    },
    resetData() {
      this.images = [
        { image: 'clustering_PCA_markers.png', data: '' },
        { image: 'clustering_tsne_markers.png', data: '' },
        { image: 'clustering_uMap_markers.png', data: '' },
        { image: 'dr_clusters_PCA_flowsom.png', data: '' },
        { image: 'dr_clusters_PCA_kmeans.png', data: '' },
        { image: 'dr_clusters_PCA_phenograph.png', data: '' },
        { image: 'dr_clusters_tsne_flowsom.png', data: '' },
        { image: 'dr_clusters_tsne_kmeans.png', data: '' },
        { image: 'dr_clusters_tsne_phenograph.png', data: '' },
        { image: 'dr_clusters_uMap_flowsom.png', data: '' },
        { image: 'dr_clusters_uMap_kmeans.png', data: '' },
        { image: 'dr_clusters_uMap_phenograph.png', data: '' },
        { image: 'flowsom_heatmap.png', data: '' },
        { image: 'kmeans_heatmap.png', data: '' },
        { image: 'phenograph_heatmap.png', data: '' },
      ]
      this.technique = 'PCA'
      this.type = 'phenograph'
      this.lbIndex = null
      this.timer = null
      this.annotation = []
      this.versionAnnotation = []
      this.annotations = {
        phenograph: [],
        kmeans: [],
        flowsom: [],
      }
      this.annotationsB = []
      this.celltypes = []
      this.test = null
      this.status = { annotation: null, markers: [], progress: { timestamp: '' } }
      this.showComputing = false
      this.annotationStatus = false
      this.imageStatus = false
      this.hasImages = false
      this.getStatus()
    },
    getPendingTask(taskPend){
    
        axios.get(`${url}:${port}/downstream-clustering-progress-pending/${taskPend}`, { headers }).then(result => {
          console.log("PENDING", result)
          if (result) {
            if(result.data.progress == undefined || result.data.progress == null){
              this.updating = false;
              this.hasImage = true;
              clearInterval(this.timer)
              this.resetData();
            }
             else {
              this.status.progress.timestamp = (result.data.progress)[1]
              
            }
          }
        })
      
     // this.getAnnotationData()
    },
    getStatus() {
      if (this.version !== null) {
        axios.get(`${url}:${port}/downstream-clustering-progress/${this.version.id}`, { headers }).then(result => {
          console.log(result)
          if (result) {
            const annotation = (result.data.progress.annotation !== '' && result.data.progress.annotation !== null) ? JSON.parse(result.data.progress.annotation) : []
            const markers = (result.data.progress.markers !== null) ? JSON.parse(result.data.progress.markers) : []
            const progress = (result.data.progress.progress.timestamp !== undefined) ? result.data.progress.progress : { timestamp: '' }
            const { hasImages } = result.data.progress
            this.status = {
              annotation, markers, progress, hasImages,
            }
            console.log(`hasImages: ${hasImages}`)
            this.hasImages = hasImages
            if (annotation.length === 0) {
              /* if (progress.timestamp === '') {
                this.clustering()
                if (this.timer === null) {
                  this.setTimer()
                }
              } */
            } else {
              this.annotationStatus = true
              clearInterval(this.timer)
            }
          }
        })
      }
      this.getAnnotationData()
    },
    async getData() {
      console.log('getData')
     // const { id } = this.$route.params
      const id = this.project_id;
      if (this.version !== null) {
        const version = this.version.id
        axios.get(`${url}:${port}/downstream/${id}/${version}`, { headers }).then(result => {
          this.images = result.data.images
          this.annotation = JSON.parse(result.data.annotation)

          this.versionAnnotation = JSON.parse(result.data.annotation)
          this.updating = false
          console.log(this.annotation)
          clearInterval(this.timer)
        })
      }
      await axios.get(`${url}:${port}/downstream-celltypes`, { headers }).then(result => {
        this.celltypes = result.data.celltypes
      })
    },
    addAnnotation(data) {
      const newAnnotation = []
      const { name } = data.name
      const { cluster } = data
      let changed = false
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.annotations[this.type].length; index++) {
        const element = this.annotations[this.type][index]
        console.log(element.cluster.cluster, cluster.cluster)
        if (element.cluster.cluster === cluster.cluster) {
          console.log(name)
          if (name !== undefined) {
            newAnnotation.push({ name, cluster })
          }
          changed = true
        } else {
          newAnnotation.push({ cluster: element.cluster, name: element.name })
        }
      }
      if (!changed) {
        newAnnotation.push({ name, cluster })
      }
      this.annotations[this.type] = newAnnotation
    

      //this.$swal.close()
    },
    getAnnotationData() {
      if (this.version !== null && this.version.id !== undefined) {
        axios.get(`${url}:${port}/downstream-annotation/${this.version.id}`, { headers }).then(result => {
          this.annotations = result.data.annotations
        })
      }
    },
    addAnnotations() {
      if (this.show_ann.cluster !== '') {

        for(var i=0; i< this.new_annot_cluster.length;i++){
          var data = { name: this.new_annot_name, cluster: this.new_annot_cluster[i] }
          this.addAnnotation(data)

        }
        this.new_annot_name = ''
      this.new_annot_cluster = []
      this.show_ann = false;
      this.sth_new = true;
       
        
        //this.add({ name: this.show_ann.name, cluster: this.show_ann.cluster })
      } else {
        this.error = true
      }
    },
    addName(newName) {
      // if (this.alphanumeric(newName)) {
      this.newNames.push({ name: newName })
      this.new_annot.name = { name: newName }
    
    },
    openForm() {  
      this.show_ann = true;
      var cellNames =  this.celltypes.concat(this.newNames)
     
      this.new_annot = { cellNames: cellNames, type: this.type, annotations: this.annotations, annotationOptions: this.annotationOptions, celltypes: this.celltypes, add: this.addAnnotation}

     /* const annotationForm = new Vue({
        ...AddAnnotation,
        parent: this,
        propsData: {
          type: this.type, annotations: this.annotations, annotationOptions: this.annotationOptions, celltypes: this.celltypes, add: this.addAnnotation,
        },
      }).$mount()
      this.$swal({
        title: '<span class="font-weight-bolder">Add Annotation</span>',
        html: annotationForm.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
      })*/
    },
    getMarkerlist(){
      const {node_id, project_id} =  this

  const markerLists = new Vue({
    ...markerlist,

    propsData: { selected: false, preprocess: true, status: {}, node_id: node_id, project_id: project_id},
  }).$mount()
  this.$swal({
    html: markerLists.$el,
    showCloseButton: true,
    showCancelButton: false,
    showConfirmButton: false,
    confirmButtonText: 'Save',
    width: '95%',


  }).then(async result => {
    
    // this.$swal.clearData()
      //console.log("MAITE CLOSE", this.$root.$refs.markerlist)

      if (result.dismiss == undefined) {
        
      }
    })

    },
    taskProgress() {
      // this.showOverlay = true
    },
    prepare_dr() {
      console.log('prepare')
      //this.drProcessTmp = true
      console.log('prepare2', this.drProcessTmp)
      Swal.fire({
      icon: 'success',
      title: 'Congratulations!',
      text: "You will receive an email as soon as the computation is finished"
  
    })
      // TODO: Avisar que se borrarán los datos DR generados.
      // this.$emit('addDr', true)
     // this.stopping = false
     // this.drProcess = true
      axios.post(`${url}:${port}/digital-prepare/${this.version.id}`, {}, { headers })
    },
    updateFigures() {
      const annotation = this.versionAnnotation
      const newfigures = []
      const node_id = this.node_id
      console.log(annotation)
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < annotation.length; index++) {
        const element = annotation[index]
        const method = element.cl_method
        // eslint-disable-next-line no-plusplus
        for (let index2 = 0; index2 < this.annotations[method].length; index2++) {
          const item = this.annotations[method][index2]
          if (item.cluster.cluster === element.cluster) {
            element.annotation = item.name
          }
        }
        newfigures.push(element)
      }
      this.showComputing = true
       this.updating = true
      const id = this.project_id;
      //const { id } = this.$route.params
      const version = this.version.id
     
      axios.post(`${url}:${port}/downstream-annotation/${id}`, { version, user_id: 1, annotation: newfigures }, { headers }).then(async result => {
          console.log("ADD ANN", result, result.data, result.data.id)
          this.setTimer(result.data.id)
         // this.updating = true;
        /* this.annotations = {
          phenograph: [],
          kmeans: [],
          flowsom: [],
          
        } */
        //this.getMarkerlist()
      //  this.getAnnotationData()
        // this.setTimer()
      })
    },
  },
}
</script>
<style>
.clustering, .heatmap{
    flex: 0 0 80%;
    max-width: 80%;
}
.clusters, .legend{
    flex: 0 0 20%;
    max-width: 20%;
}

.clusters, .clustering, .heatmap{
    cursor:pointer;
}
.annoSel .vs__dropdown-toggle{
    height: 38px;
}
.btn-select{
    width: 280px;
    text-align: left !important;
    font-size: 1em !important;
    line-height: 1.4 !important;
    color: black !important;
    text-align: left !important;

}
.selectItem{
  font-size: 1em !important;
  line-height: 1.4 !important;
  font-family: inherit !important;
  font-weight: normal !important;
  
}
.selectList .selectItem{

}
.selectItem span{
  margin-left: 3px !important;
}

.selectItem .input{
  margin-right: 3px;
}
.add-annot{
  padding:3rem 5rem;
  border: 1px solid grey;
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

}
.helperContainer{
  display: none;
}
.caret{
  display: none !important;
}
</style>